import React, { Component } from "react";
import { connect } from "react-redux";
import ChangeRegionalDatabase from "../components/TrackedKeywords/ChangeRegionalDatabase";
import { fetchRegionalDatabases } from "../store/regional_databases/operations";
import { getRegionalDatabases } from "../store/regional_databases/selectors";
import { changeKeywordsSeoDb } from "../store/tracked_keywords/operations";
import { updateSettings } from "../store/tracked_websites/operations";
import { isChangingSeoDb } from "../store/tracked_keywords/selectors";

class ChangeSeoDb extends Component {
  componentDidMount = (_) => {
    this.props.fetchRegionalDatabases();
  };
  handleChangeSeoDb = (domain, newSeoDb) => {
    this.props.changeKeywordsSeoDb(domain, newSeoDb, this.props.postAction);
    let settings = { seo_db: newSeoDb };
    this.props.updateSettings(domain, settings, "changeSeoDb", this.props.postAction);
    if (this.props.postAction === "reload_top_keywords") {
      this.props.resetSortBy("tr_desc");
    }
  };
  render() {
    return (
      <ChangeRegionalDatabase
        domain={this.props.domain}
        seoDb={this.props.seoDb}
        regionalDatabases={this.props.regionalDatabases}
        isChangingSeoDb={this.props.isChangingSeoDb}
        changeSeoDb={(domain, newSeoDb) => this.handleChangeSeoDb(domain, newSeoDb)}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  isChangingSeoDb: isChangingSeoDb(state),
  regionalDatabases: getRegionalDatabases(state),
});

export default connect(mapStateToProps, {
  fetchRegionalDatabases,
  changeKeywordsSeoDb,
  updateSettings,
})(ChangeSeoDb);
